// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************************************
 ******************** FMS custom variables *********************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables before ****************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables after ****************
 **************************************************************/
/* Alerts */
/* Badges */
/* Modals */
/* Dropdowns */
.left-menu {
  position: relative;
  flex: 0 0 171px;
  display: flex;
  flex-direction: column;
}
.left-menu .header {
  padding: 20px 1.25rem 19px;
  margin-bottom: 0;
  background-color: #c4deff;
  border-top: 1px solid #c4deff;
}
.left-menu .menu-toggle {
  position: absolute;
  top: 22px;
  left: 155px;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: #c4deff;
  color: #1161be;
  z-index: 1;
}
.left-menu .menu-toggle i-feather {
  position: relative;
  top: 4px;
  left: 4px;
}
.left-menu .body {
  flex-grow: 1;
  color: #1161be;
  background-color: #c4deff;
}
.left-menu .body .item-large {
  padding: 17px 0 17px 20px;
  outline: none;
}
.left-menu .body .item-large h4 {
  color: #1161be;
}
.left-menu .body .item-board {
  background-color: #b2d3fc;
}
.left-menu .body .item-small {
  display: block;
  padding: 10px 0 10px 50px;
  font-size: 14px;
  font-weight: normal;
  text-decoration: none;
}
.left-menu .body .item-small.selected {
  background-color: #94c2fc;
}

.left-menu.hidden {
  flex: 0 0 72px;
}
.left-menu.hidden .header a.btn {
  width: 36px;
  padding: 5.25px 7px;
}
.left-menu.hidden .menu-toggle {
  left: 56px;
}
.left-menu.hidden .body .item-large {
  padding-left: 26px;
}
.left-menu.hidden .body #board-dropdown.dropdown-menu {
  left: 100% !important;
  top: 0 !important;
  padding: 0;
  margin-top: 0;
  border: none;
  border-radius: 0;
  width: auto !important;
}
.left-menu.hidden .body #board-dropdown.dropdown-menu .item-small {
  padding: 10px 20px 10px 20px;
}

.boards {
  margin: 0 -9px;
}

.board-col {
  width: 16.66%;
  padding: 0 3px;
}

.board-col-title {
  margin-bottom: 10px;
}

.task-count {
  min-width: 17px;
  height: 22px;
  padding: 0px 5px;
  color: #1161be;
  background-color: #c4deff;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  line-height: 22px;
}

.site-name {
  color: #1161be;
  background-color: #c4deff;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 18px;
}

.dropdown-menu .dropdown-item {
  font-size: 12px;
}

.dropdown-menu {
  margin: 0px;
}

.main-container {
  padding: 34px 25px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/app/boards/board-view/board-view.component.scss"],"names":[],"mappings":"AACA;;+DAAA;AAwDA;;+DAAA;AAuBA;;+DAAA;AAgGA,WAAA;AAIA,WAAA;AAMA,WAAA;AAMA,cAAA;AC5LA;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAUF;AARE;EACE,0BAAA;EACA,gBAAA;EACA,yBAXS;EAYT,6BAAA;AAUJ;AAPE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAtBS;EAuBT,cDfO;ECgBP,UAAA;AASJ;AAPI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AASN;AALE;EACE,YAAA;EACA,cD3BO;EC4BP,yBApCS;AA2Cb;AALI;EACE,yBAAA;EACA,aAAA;AAON;AALM;EACE,cDnCG;AC0CX;AAHI;EACE,yBAAA;AAKN;AAFI;EACE,cAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AAIN;AADI;EACE,yBAAA;AAGN;;AAEA;EACE,cAAA;AACF;AACE;EACE,WAAA;EACA,mBAAA;AACJ;AAEE;EACE,UAAA;AAAJ;AAII;EACE,kBAAA;AAFN;AAKI;EACE,qBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AAHN;AAKM;EACE,4BAAA;AAHR;;AASA;EACE,cAAA;AANF;;AASA;EACE,aAAA;EACA,cAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,cD3GS;EC4GT,yBApHW;EAqHX,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AANF;;AASA;EACE,cDpHS;ECqHT,yBA7HW;EA8HX,aAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AANF;;AAQA;EACE,eAAA;AALF;;AAOA;EAAe,WAAA;AAHf;;AAKA;EACE,kBAAA;AAFF","sourcesContent":["\n/***************************************************************\n ******************** FMS custom variables *********************\n **************************************************************/\n$fms-white: #fff;\n$fms-black: #000;\n\n$fms-gray-text: #252525;\n\n//primary\n$fms-blue: #1161be;\n//$fms-blue-dark: #00264f;\n$fms-blue-light: #e1eefe;\n$fms-gray-dark: #252525;\n$fms-gray: #8291ae;\n$fms-gray-light: #f7f8fc;\n\n// $fms-gray-tone: #f0f3f2;\n// $fms-gray-bg: #f9fbfc;\n// $fms-gray-border: #e9eef0;\n// $fms-link-color: #248cfc;\n$fms-green: #1ba953;\n$fms-green-light: #daf8e6;\n\n$fms-yellow: #fbcd1e;\n$fms-yellow-light: #fff4cb;\n//secondary\n\n\n$fms-blue-secondary: #bee7ff;\n\n$fms-purple: #ebe8fc;\n$fms-orange: #ff612c;\n$fms-red: #f64540;\n$fms-pink: #ff5b84;\n\n\n\n$fms-error: $fms-red;\n$fms-pending: $fms-yellow;\n$fms-positive: $fms-green;\n$fms-padding-x: 1.375rem;\n// $fms-grid-border-color: $fms-gray-light;\n// $fms-grid-color: $fms-gray-dark;\n// $fms-grid-header-background-color: $fms-white; //$fms-gray-light;\n// $fms-grid-row-even-background-color: $fms-white;\n// $fms-grid-row-hover-background-color:#E1F1F7;\n// $fms-grid-row-padding-y: 1.4rem; //original 1.5rem\n// $fms-checkbox-size: 1.25rem;\n// $fms-checkbox-size-sm: .875rem;\n// $fms-checkbox-size-lg: 1.875rem;\n$fms-font-family: 'Noto Sans';\n// $fms-font-family-medium: \"Graphik Medium\";\n// $fms-font-family-bold: \"Graphik Bold'\";\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables before ****************\n **************************************************************/\n\n\n$btn-disabled-opacity: .35;\n$input-btn-focus-box-shadow: none;\n$input-btn-active-box-shadow: none;\n$btn-box-shadow: none;\n$btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n\n$body-bg: $fms-gray-light;\n$body-color: $fms-gray-dark;\n\n\n\n@import 'node_modules/bootstrap/scss/functions';\n@import 'node_modules/bootstrap/scss/variables';\n\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables after ****************\n **************************************************************/\n\n$grid-breakpoints: (xs: 0,\nsm: 1px,\nmd: 2px,\nlg: 3px,\nxl: 100px);\n\n\n//Fonts\n$font-family-sans-serif: $fms-font-family;\n$font-family-base: $font-family-sans-serif;\n\n\n$link-color: $fms-blue;\n//$link-color-active: $fms-blue;\n\n$theme-colors: (\"primary\": $fms-blue,\n\"warning\": $fms-pending,\n\"danger\": $fms-red,\n\"info\": $fms-blue,\n\"success\": $fms-green);\n\n\n\n//Headings\n//$headings-font-family: $fms-font-family-medium;\n$headings-color: $fms-gray-dark;\n$headings-font-weight: bold;\n// $headings-margin-bottom: 1.5rem;\n// $h1-font-size: 2.44125rem;\n// $h2-font-size: 1.953125rem;\n// $h3-font-size: 1.563125rem;\n// $h4-font-size: 1.25rem;\n// $h1-line-height: 3.125rem; //fms var\n// $h2-line-height: 2.625rem; //fms var\n// $h3-line-height: 1.875rem; //fms var\n// $h4-line-height: 1.5rem; //fms var\n\n//Nav\n$navbar-padding-y: $spacer *  0.75;\n$navbar-padding-x: $spacer * 2;\n\n$navbar-light-color: $fms-gray-text;\n$navbar-light-hover-color: $link-hover-color;\n$navbar-light-active-color: $link-hover-color;\n$navbar-light-disabled-color: rgba($fms-gray-text, .3);\n\n\n//Card\n\n$card-cap-bg: $fms-white;\n$card-bg: $fms-gray-light;\n\n//Table\n\n$table-bg: $fms-white;\n$table-accent-bg: $fms-gray-light;\n$table-hover-bg: rgba($component-active-bg, .2);\n$table-active-bg:  rgba($component-active-bg, .3);\n\n//Small text\n// $small-font-size: 0.8125rem;\n// $small-line-height: 1.125rem; //bac var\n\n// Buttons + Forms\n\n//\n// $btn-padding-y: .575rem;\n// $btn-padding-y-lg: $btn-padding-y;\n// $btn-padding-x-sm: 1.25rem;\n// $btn-padding-y-sm: .40625rem;\n// $btn-border-radius: .3rem;\n// $btn-border-radius-lg: $btn-border-radius;\n// $btn-border-radius-sm: $btn-border-radius;\n// $input-color: $fms-gray-dark;\n// $input-border-radius: 0;\n// $input-border-radius-lg: $input-border-radius;\n// $input-border-radius-sm: $input-border-radius;\n// $input-border-color: $fms-gray;\n// $input-border-width: 0.0625rem; //1px\n\n// $input-padding-x: .75rem;\n// $input-padding-y: .938rem;\n// $form-group-margin-bottom: 2rem;\n\n//Paragrahs\n//$paragraph-margin-bottom: .5rem;\n\n//Cards\n// $card-border-color: $fms-gray-border;\n// $card-spacer-x: $fms-padding-x;\n\n\n/* Alerts */\n// $alert-padding-y: .5rem;\n// $alert-padding-x: .625rem;\n\n/* Badges */\n\n// $badge-padding-x: 1rem;\n// $badge-padding-y: .2rem;\n// $badge-border-radius: .25rem;\n\n/* Modals */\n// $modal-lg: 684px;\n// $modal-content-border-radius: 0;\n// $modal-backdrop-bg: $fms-blue-dark;\n// $modal-backdrop-opacity: .8;\n\n/* Dropdowns */\n//$dropdown-item-padding-x: .9375rem\n","@import \"../../../styles/variables\";\n\n$board-blue: #c4deff;\n\n.left-menu {\n  position: relative;\n  flex: 0 0 171px;\n  display: flex;\n  flex-direction: column;\n\n  .header {\n    padding: 20px 1.25rem 19px;\n    margin-bottom: 0;\n    background-color: $board-blue;\n    border-top: 1px solid $board-blue;\n  }\n\n  .menu-toggle {\n    position: absolute;\n    top: 22px;\n    left: 155px;\n    width: 32px;\n    height: 32px;\n    border-radius: 16px;\n    background-color: $board-blue;\n    color: $fms-blue;\n    z-index: 1;\n\n    i-feather {\n      position: relative;\n      top: 4px;\n      left: 4px;\n    }\n  }\n\n  .body {\n    flex-grow: 1;\n    color: $fms-blue;\n    background-color: $board-blue;\n\n    .item-large {\n      padding: 17px 0 17px 20px;\n      outline: none;\n\n      h4 {\n        color: $fms-blue;\n      }\n    }\n\n    .item-board {\n      background-color: #b2d3fc;\n    }\n\n    .item-small {\n      display: block;\n      padding: 10px 0 10px 50px;\n      font-size: 14px;\n      font-weight: normal;\n      text-decoration: none;\n    }\n\n    .item-small.selected {\n      background-color: #94c2fc;\n    }\n  }\n}\n\n.left-menu.hidden {\n  flex: 0 0 72px;\n\n  .header a.btn {\n    width: 36px;\n    padding: 5.250px 7px;\n  }\n\n  .menu-toggle {\n    left: 56px;\n  }\n\n  .body {\n    .item-large {\n      padding-left: 26px;\n    }\n\n    #board-dropdown.dropdown-menu {\n      left: 100% !important;\n      top: 0 !important;\n      padding: 0;\n      margin-top: 0;\n      border: none;\n      border-radius: 0;\n      width: auto !important;\n\n      .item-small {\n        padding: 10px 20px 10px 20px;\n      }\n    }\n  }\n}\n\n.boards {\n  margin: 0 -9px;\n}\n\n.board-col {\n  width: 16.66%;\n  padding: 0 3px;\n}\n\n.board-col-title {\n  margin-bottom: 10px;\n}\n\n.task-count {\n  min-width: 17px;\n  height: 22px;\n  padding: 0px 5px;\n  color: $fms-blue;\n  background-color: $board-blue;\n  font-size: 12px;\n  font-weight: bold;\n  text-align: center;\n  line-height: 22px;\n}\n\n.site-name {\n  color: $fms-blue;\n  background-color: $board-blue;\n  padding: 10px;\n  font-size: 14px;\n  font-weight: bold;\n  margin-bottom: 18px;\n}\n.dropdown-menu .dropdown-item{\n  font-size: 12px;\n}\n.dropdown-menu{margin: 0px}\n\n.main-container{\n  padding: 34px 25px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
